module.exports = __webpack_public_path__ + "static/media/rupees.8d6c1b11.svg";